<Router routes={routes} />

<script>
  import Router from './utils/router.html';
  import Home from './routes/home.html';
  import About from './routes/about.html';
  import Person from './routes/people/person.html';
  import People from './routes/people/people.html';
  import Events from './routes/events/events';
  import Event from './routes/events/event';
  import EventAdd from './routes/events/event.add';
  import Programs from './routes/programs/programs';
  import Program from './routes/programs/program';
  import ProgramAdd from './routes/programs/program.add';
  import Coordinators from './routes/coordinators/coordinators';
  import Coordinator from './routes/coordinators/coordinator';
  import CoordinatorAdd from './routes/coordinators/coordinator.add';
  import Leaders from './routes/leaders/leaders';
  import Leader from './routes/leaders/leader';
  import LeaderAdd from './routes/leaders/leader.add';
  import Sponsors from './routes/sponsors/sponsors';
  import Sponsor from './routes/sponsors/sponsor';
  import SponsorAdd from './routes/sponsors/sponsor.add';
  import Households from './routes/households/households.html';
  import Household from './routes/households/household.html';
  import ProgramPlan from './routes/programs/program.plan.html';
  import Reporting from './routes/reporting/reporting';

  export const routes = [
    {path:'/', component: Programs, section: 'programs'},
    {path: '/people', component: People, section: 'people'},
    {path: '/people/view/:id', component: Person, section: 'people'},
    {path: '/people/view/:id/:section', component: Person, section: 'people'},
    {path: '/households', component: Households, section: 'households'},
    {path: '/households/view/:id', component: Household, section: 'households'},
    {path: '/households/view/:id/:section', component: Household, section: 'households'},
    {path: '/events', component: Events, section: 'events'},
    {path: '/events/new', component: EventAdd, section: 'events'},
    {path: '/events/new/:program', component: EventAdd, section: 'events'},
    {path: '/events/view/:id', component: Event, section: 'events'},
    {path: '/events/view/:id/:section', component: Event, section: 'events'},
    {path: '/programs', component: Programs, section: 'programs'},
    {path: '/programs/plan', component: ProgramPlan, section: 'programs', sub: 'planning'},
    {path: '/programs/new', component: ProgramAdd, section: 'programs'},
    {path: '/programs/view/:id', component: Program, section: 'programs'},
    {path: '/programs/view/:id/:section', component: Program, section: 'programs'},
    {path: '/coordinators', component: Coordinators, section: 'programs', sub: 'coordinators'},
    {path: '/coordinators/new', component: CoordinatorAdd, section: 'programs', sub: 'coordinators'},
    {path: '/coordinators/view/:id', component: Coordinator, section: 'programs', sub: 'coordinators'},
    {path: '/leaders', component: Leaders, section: 'programs', sub: 'leaders'},
    {path:'/leaders/new', component: LeaderAdd, section: 'programs', sub: 'leaders'},
    {path: '/leaders/view/:id', component: Leader, section: 'programs', sub: 'leaders'},
    {path: '/sponsors', component: Sponsors, section: 'programs', sub: 'sponsors'},
    {path: '/sponsors/new', component: SponsorAdd, section: 'programs', sub: 'sponsors'},
    {path: '/sponsors/view/:id', component: Sponsor, section: 'programs', sub: 'sponsors'},
    {path: '/sponsors/view/:id/:section', component: Sponsor, section: 'programs', sub: 'sponsors'},
    {path: '/reporting', component: Reporting, section: 'reporting'},
  ];
</script>